<template>
  <div class="body-box marginBox2">
    <el-row class="plan"></el-row>
    <el-form
      ref="addFormRef"
      :model="addForm"
      :rules="rules"
      label-width="140px"
      style="padding: 20px;background-color: #fff;margin-top: 10px;"
    >
      <el-row>
        <!--球场名称-->
        <el-col :span="8">
          <el-form-item label="球场名称" prop="name">
            <el-input v-model="addForm.name" placeholder="请输入球场名称" />
          </el-form-item>
        </el-col>

        <!--手机号-->
        <el-col :span="8">
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="addForm.phone" placeholder="请输入手机号" />
          </el-form-item>
        </el-col>

        <!--开业年份-->
        <el-col :span="8">
          <el-form-item label="开业年份" prop="year">
            <el-input v-model="addForm.year" placeholder="请输入开业年份" />
          </el-form-item>
        </el-col>

        <!--设计师-->
        <el-col :span="8">
          <el-form-item label="设计师" prop="designer">
            <el-input v-model="addForm.designer" placeholder="请输入设计师" />
          </el-form-item>
        </el-col>

        <!--孔数-->
        <el-col :span="8">
          <el-form-item label="孔数" prop="holesNumber">
            <el-input v-model="addForm.holesNumber" placeholder="请输入孔数" />
          </el-form-item>
        </el-col>

        <!--是否在首页显示-->
        <el-col :span="8">
          <el-form-item label="是否在首页显示" prop="index">
            <el-select v-model="addForm.index" clearable placeholder="请选择是否在首页显示" style="width: 100%">
              <el-option key="YES" label="是" value="YES"></el-option>
              <el-option key="NO" label="否" value="NO"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--地址-->
        <el-col :span="8">
          <el-form-item label="地址" prop="addr.addr">
            <el-input v-model="addForm.addr.addr" placeholder="请输入地址" @change="changeAddr" />
          </el-form-item>
        </el-col>

        <!--排序-->
        <el-col :span="8">
          <el-form-item label="排序" prop="sort">
            <el-input v-model="addForm.sort" placeholder="请输入排序" />
          </el-form-item>
        </el-col>

        <!--假期价格-->
        <el-col :span="8">
          <el-form-item label="假期价格" prop="fee.blueTeePrice">
            <el-input v-model="addForm.fee.blueTeePrice" placeholder="请输入假期价格" />
          </el-form-item>
        </el-col>

        <!--平时价格-->
        <el-col :span="8">
          <el-form-item label="平时价格" prop="fee.costPrice">
            <el-input v-model="addForm.fee.costPrice" placeholder="请输入平时价格" />
          </el-form-item>
        </el-col>

        <!--穿梭车列表-->
        <el-col :span="24" style="padding: 0 140px 20px 140px;font-size: 20px;margin-top: 30px;">
          <span>穿梭车</span>
          <span class="el-icon-circle-plus-outline" style="margin-left: 16px;cursor: pointer" @click="addNum"></span>
        </el-col>

        <!--穿梭车-->
        <el-col :span="24">
          <el-form label-width="140px">
            <div v-for="(item,index) in shuttleBus" :key="index" class="shuttle_bus">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="乘车人数">
                    <el-input v-model="item.busNumber" placeholder="请输入乘车人数" />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="往返价格">
                    <el-input v-model="item.tripPrice" placeholder="请输入往返价格" />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="车种">
                    <el-input v-model="item.vehicles" placeholder="请输入车辆类型" />
                  </el-form-item>
                </el-col>
              </el-row>

              <span v-if="shuttleBus.length > 1" @click="subtract(index)" class="location_box el-icon-remove-outline" style="font-size: 20px;cursor: pointer"></span>
            </div>
          </el-form>
        </el-col>

        <!--设施及其他-->
        <el-col :span="24" style="padding: 0 140px 20px 140px;font-size: 20px;margin-top: 30px;">
          <span>设施及其他</span>
          <span class="el-icon-circle-plus-outline" style="margin-left: 16px;cursor: pointer" @click="addFacility"></span>
        </el-col>

        <!--设施及其他-->
        <el-col :span="24">
          <el-form label-width="140px">
            <div v-for="(item,index) in facilityList" :key="index" class="shuttle_bus">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="图标">
                    <el-input v-model="item.icon" placeholder="请输图标" />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="设施">
                    <el-input v-model="item.label" placeholder="请输入设施" />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="值">
                    <el-input v-model="item.value" placeholder="请输入值" />
                  </el-form-item>
                </el-col>
              </el-row>

              <span v-if="facilityList.length > 1" @click="subtractFacility(index)" class="location_box el-icon-remove-outline" style="font-size: 20px;cursor: pointer"></span>
            </div>
          </el-form>
        </el-col>

        <!--轮播图-->
        <el-col :span="24">
          <el-form-item label="轮播图">
            <thumbnail-list v-model="addForm.carousel" :md5List="addForm.carousel"></thumbnail-list>
          </el-form-item>
        </el-col>

        <!--缩略图-->
        <el-col :span="24">
          <el-form-item label="缩略图">
            <thumbnail @getFiles="getThumbnailMd5" :md5s="addForm.thumbnail"></thumbnail>
          </el-form-item>
        </el-col>

        <!--&lt;!&ndash;积分卡A面图片&ndash;&gt;
        <el-col :span="24">
          <el-form-item label="积分卡A面">
            <thumbnail @getFiles="getMd5A" :md5s="addForm.scoreCardList[0].images"></thumbnail>
          </el-form-item>
        </el-col>

        &lt;!&ndash;积分卡B面图片&ndash;&gt;
        <el-col :span="24">
          <el-form-item label="积分卡B面">
            <thumbnail @getFiles="getMd5B" :md5s="addForm.scoreCardList[1].images"></thumbnail>
          </el-form-item>
        </el-col>-->

        <!--设施及其他-->
        <el-col :span="24" style="padding: 0 140px 20px 140px;font-size: 20px;margin-top: 30px;">
          <span>积分卡</span>
          <span class="el-icon-circle-plus-outline" style="margin-left: 16px;cursor: pointer" @click="addIntegral"></span>
        </el-col>

        <!--积分卡图片-->
        <el-col :span="24" v-for="(item, index) in addForm.scoreCardList" :key="index" class="label">
          <integrogram :certifications="addForm.scoreCardList" :index="index"></integrogram>
        </el-col>

        <!--路程-->
        <el-col :span="24">
          <el-form-item label="路程" prop="distance">
            <el-input type="textarea" v-model="addForm.distance" placeholder="请输入路程" />
          </el-form-item>
        </el-col>

        <!--球场介绍-->
        <el-col :span="24">
          <el-form-item label="球场介绍" prop="introduce">
            <el-input type="textarea" v-model="addForm.introduce" placeholder="请输入球场介绍" />
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>

    <div class="goBackBox">
      <el-button @click="goBack">返 回</el-button>
      <el-button @click="addCourt">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { addCourt, getCourtDetails } from '@/api/court/court'
import { getData } from '@/utils/code'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import ThumbnailList from '@/components/common/thumbnailList/thumbnailList'
import Integrogram from '@/components/common/integrogram/integrogram'
import { courtRules } from '@/js/rules'

export default {
  components: { ThumbnailList, Thumbnail, Integrogram },
  data() {
    return {
      //穿梭车
      shuttleBus: [
        {
          busNumber: '',
          tripPrice: '',
          vehicles: ''
        }
      ],
      //设施及其他
      facilityList: [
        {
          icon: 'iconfont icon-chuzu',
          label: 'クラブバス',
          value: 'なし'
        },{
          icon: 'iconfont icon-cabin',
          label: '貸しクラブ',
          value: '300元/1セット'
        },{
          icon: 'iconfont icon-bhjgolf',
          label: '練習場',
          value: 'あり'
        },{
          icon: 'iconfont icon-shijian',
          label: 'ﾚﾝﾀﾙｼｭｰｽﾞ',
          value: '80元/1足'
        },{
          icon: 'iconfont icon-sheshi',
          label: '宿泊施設',
          value: 'なし'
        },{
          icon: 'iconfont icon-banshidating',
          label: '宴会ホール',
          value: 'あり'
        },
      ],
      addForm: {
        addr: {},
        fee: {},
      }, //添加组织表单
      addDialogVisible: true,
      // 规则
      rules: courtRules
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getDetails()
  },
  methods: {
    getDetails() {
      getCourtDetails(this.id).then(res => {
        this.addForm = res.code === '0' ? res.data : {}
        this.shuttleBus = JSON.parse(res.data.rules[0].content)
        this.facilityList = JSON.parse(res.data.rules[1].content)
        this.scoreCardList = res.data.scoreCardList
      })
    },

    //添加一行穿梭车
    addNum() {
      let obj = {
        busNumber: '',
        tripPrice: '',
        vehicles: ''
      }
      this.shuttleBus.push(obj)
    },

    //删除一行穿梭车
    subtract(i) {
      if (this.shuttleBus.length > 1) {
        this.shuttleBus.splice(i,1)
      }
    },

    //添加一行设施
    addFacility() {
      let obj = {
        icon: '',
        label: '',
        value: ''
      }
      this.facilityList.push(obj)
    },

    //删除一行穿梭车
    subtractFacility(i) {
      if (this.facilityList.length > 1) {
        this.facilityList.splice(i,1)
      }
    },

    //获取缩略图
    getThumbnailMd5(obj) {
      this.addForm.thumbnail = obj.md5
    },

    //a面
    getMd5A(md5) {
      this.addForm.scoreCardList[0].images = md5.md5
    },

    //b面
    getMd5B(md5) {
      this.addForm.scoreCardList[1].images = md5.md5
    },

    //查询经纬度
    changeAddr() {
      /*const val = {
        addr: this.addForm.addr.addr
      }
      getLngLatByAddr(val).then(res => {
        if (res.code === '0') {
          this.addForm.addr.lat = res.data.lat
          this.addForm.addr.lng = res.data.lng
        }else {
          this.addForm.addr.addr = ''
          this.$message.error('地址查询失败,请填写详细地址');
        }
      })*/
    },

    // 添加
    addCourt() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        let flag = true
        //判断穿梭车和设备及其他
        this.facilityList.forEach(f => {
          if (!f.icon || !f.label || !f.value) {
            return flag = false
          }
        })
        this.shuttleBus.forEach(f => {
          if (!f.busNumber || !f.tripPrice || !f.vehicles) {
            return flag = false
          }
        })
        //判断积分卡正反面
        this.addForm.scoreCardList.forEach(f => {
          if (!f.images) {
            return flag = false
          }
        })
        if (flag && this.addForm.carousel) {
          this.addForm.rules[0].content = JSON.stringify(this.shuttleBus)
          this.addForm.rules[1].content = JSON.stringify(this.facilityList)

          addCourt(this.addForm).then(res => {
            let data = getData(res)
            if (data !== null) {
              this.$router.go(-1)
            }
          })
        }else {
          this.$message.error('请完善信息哦');
        }
      })
    },

    //返回上一级
    goBack() {
      this.$router.go(-1)
    }

  }
}
</script>

<style scoped lang="less">
/deep/.el-input {
  width: 90%;
}
/deep/ .shuttle_bus {
  position: relative;
  .location_box {
    position: absolute;
    top: 8px;
    right: 10px;
  }
}
/deep/.el-form-item__label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
</style>
